import { FlagType } from '~/flags/flags';
import { getFlag } from '~/flags/useFlag';
import { canUseWorkflow } from '~/permissions/canUseWorkflow';

import { RoutePathType } from '../enums';
import { Component, RouteResolver } from '../types';

/**
 * Resolvers for the WSS-originated intake-form link route, which is shared
 * between legacy and CLM Evolution workflows on one fixed URL WSS already
 * points at (`/integrate-workflow/:workflowId/intake-form/link`) — there is
 * no per-workflow signal to dispatch on, so this keys off the same
 * tenant-wide flag both sides of the WSS integration already gate on
 * (`FlagType.WSSIntegrationWithCLMEPhase1` / K2's `Flag.WSS_INTEGRATION_PHASE_1`):
 * - Flag on: resolves to `clmeComponent`.
 * - Flag off: falls back to `legacyComponent`, gated the same way
 *   `createWorkflowResolvers` gates it today.
 * - Neither: redirects to RoutePathType.Home.
 */
export const createIntegrateWorkflowIntakeFormResolvers = (
  clmeComponent: Component,
  legacyComponent: Component,
): RouteResolver[] => {
  return [
    {
      permission: () => getFlag(FlagType.WSSIntegrationWithCLMEPhase1),
      component: clmeComponent,
    },
    {
      permission: canUseWorkflow,
      component: legacyComponent,
    },
    {
      redirectPath: RoutePathType.Home,
    },
  ];
};
